import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { FOOTNOTE_INDICATOR, DEALER_OFFER } from '../constants/constants';

export default class IncentiveLink extends React.Component {
	constructor(props) {
		super(props);
		this.getOfferTitle = this.getOfferTitle.bind(this);
	}

	getOfferTitle(prefs, labels) {
		const {
			incentive: { title, shortTitle }
		} = this.props;
		let offerTitle;

		switch (prefs.incentiveTitleDisplay) {
			case 'regular':
				offerTitle = title;
				break;
			case 'custom':
				offerTitle =
					labels.get(prefs.incentiveTitleCustom) ||
					labels.get(DEALER_OFFER);
				break;
			default:
				offerTitle = shortTitle;
		}

		return offerTitle;
	}

	render() {
		const { incentive, showModal, showFootnote } = this.props;
		let footnoteIndicator = null;

		if (showFootnote) {
			footnoteIndicator = (
				<span className="footnote-indicator">{FOOTNOTE_INDICATOR}</span>
			);
		}

		return (
			<Common
				render={({ prefs, labels }) => {
					return (
						<li className="py-3 my-0">
							<button
								className="text-link text-left"
								onClick={() => showModal(incentive)}
							>
								<span className="incentive-title">
									{this.getOfferTitle(prefs, labels)}
								</span>
								{footnoteIndicator}
							</button>
						</li>
					);
				}}
			/>
		);
	}
}

IncentiveLink.propTypes = {
	incentive: PropTypes.shape({
		key: PropTypes.string,
		title: PropTypes.string.isRequired,
		shortTitle: PropTypes.string.isRequired
	}).isRequired,
	showModal: PropTypes.func.isRequired,
	showFootnote: PropTypes.bool
};

IncentiveLink.defaultProps = {
	showFootnote: false
};



// WEBPACK FOOTER //
// ./src/components/IncentiveLink.jsx